import React from "react";

//package import

import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	Button,
	DialogTitle,
} from "@mui/material";
import { ROLE_METHODS, titlizeString } from "../common/functions";

//component

const ConfirmationDialogue = ({ data, open, handleClose, confirmHandler }) => {
	//hooks

	// render

	return (
		<Dialog
			open={open}
			onClose={handleClose}
			fullWidth={true}
			sx={{
				color: "gray",
				borderRadius: 2,
			}}
		>
			<DialogTitle>{}</DialogTitle>
			<DialogContent>
				<DialogContentText sx={{ textAlign: "center" }}>
					{`Are you sure you want to ${
						data?.is_active ? "Active" : "Inactive"
					} the ${
						data?.role === "pou"
							? "POU (point of use)"
							: titlizeString(ROLE_METHODS.appBasedRole(data?.role))
					}
					?`}
				</DialogContentText>
			</DialogContent>
			<DialogActions sx={{ marginTop: 5, margin: "auto" }}>
				<Button
					onClick={handleClose}
					variant="contained"
					sx={{ borderRadius: 2 }}
				>
					Cancel
				</Button>

				<Button
					variant="contained"
					onClick={confirmHandler}
					sx={{
						backgroundColor: "gray",
						borderRadius: 2,
					}}
					autoFocus
				>
					Yes
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ConfirmationDialogue;
